import { SxProps, Theme } from '@mui/material';

export const tabsStyles: SxProps<Theme> = {
    mb: 3,
    borderBottom: 1,
    borderColor: 'divider',
};
